"use client";
import { IBlog } from "@/api/AppApi/services/home/interfaces/Blog";
import React from "react";
import BlogMiniCard from "../../../common/blog-cards/BlogMiniCard";
import { useIsMobile } from "@/hooks/useIsMobile";
import SvgArrow from "./SvgArrow";
import { Link } from "@/app/components/lib/navigation/Link";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useIsRtl from "@/hooks/useIsRtl";

interface props {
  next?: IBlog | null;
  prev?: IBlog | null;
}
const PrevNextBlogs: React.FC<props> = ({ next, prev }) => {
  const isMobile = useIsMobile();
  const t = useTranslation();
  const isRtl = useIsRtl();
  return (
    <>
      {(!!next || !!prev) && (
        <h2 className="hide-to-vistor">{t.related_articles}</h2>
      )}
      <ul
        className=" d-flex justify-content-between m-0 p-0 "
        style={{ listStyleType: "none" }}
      >
        {prev && (
          <BlogMiniCard
            title={prev?.title!}
            imgSrc={prev?.image_url!}
            direction={isMobile ? "vertical" : "horazonal"}
            withBorder={true}
            id={prev?.id!}
            slug={prev?.slug!}
            action={
              <Link prefetch={false} href={PagesPaths.blogDetails + prev?.slug}>
                <div className="action-btn">
                  <SvgArrow right={isRtl} />
                  {t.previous}
                </div>
              </Link>
            }
            actionAlign="start"
            imageSize={{ height: 78, width: 115 }}
          />
        )}
        {next && (
          <BlogMiniCard
            title={next?.title!}
            imgSrc={next?.image_url!}
            direction={isMobile ? "vertical" : "horazonal"}
            withBorder={true}
            id={next?.id!}
            slug={next?.slug!}
            action={
              <Link href={PagesPaths.blogDetails + prev?.slug}>
                <div className="action-btn">
                  {t.next}
                  <SvgArrow right={!isRtl} />
                </div>
              </Link>
            }
            actionAlign={isMobile ? "end" : "start"}
            imageSize={{ height: 78, width: 115 }}
          />
        )}
      </ul>
    </>
  );
};

export default PrevNextBlogs;
